import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Modal, Input, Select, TimePicker,Form,Space, InputNumber, Radio } from 'antd';
import { AddDesignation, BASE_URL, UpdateDesignation } from '../../utils/constant';

import { ToastContainer, toast } from 'react-toastify';



const DesignationForm = ({ visible, onCancel, onAddOrUpdate, initialValues }) => {
    const { handleSubmit, register, reset } = useForm();
    const [form] = Form.useForm(); 

    const handleCancel = () => {
        onCancel();
    
    };
    useEffect(() => {
      console.log('initialValuezs',initialValues)
        if (!initialValues || Object.keys(initialValues).length === 0) {
          // If initialValues is null or an empty object, set form fields to be empty
          form.resetFields();
        } else {
          form.setFieldsValue(initialValues);
        }
      }, [initialValues, form]);
    const handleOk = async () => {
        try {
            await form.validateFields(); // Validate form fields
            const values = form.getFieldsValue(); // Get form values
            let isError = false;

            // Validate each required field
            const requiredFields = [
              "designationName",
              "designationShortName",
            ];
        
            requiredFields.forEach((fieldName) => {
              if (!values[fieldName] && values[fieldName] !== 0) {
                toast.error(`Please fill in the ${fieldName.replace(/([A-Z])/g, ' $1').toLowerCase()} field.`);
                isError = true;
              }
            });
        
            // If any error occurred, return early
            if (isError) {
              return;
            }
            console.log('values',values)
            console.log('initialValues',initialValues)
            if (initialValues) {
                values['designationId'] = initialValues?.designationId;

                await onAddOrUpdate(values);
                form.setFieldsValue(null);
                form.resetFields();
                console.log(' form.setFieldsValue', form.setFieldsValue)
              } else {
                await onAddOrUpdate(values);
                form.setFieldsValue(null);
                form.resetFields();
                console.log(' form.setFieldsValue', form.setFieldsValue)
            }           
        } catch (error) {
            console.error('Error validating fields:', error);
        }
    };
    const validatePfNumber = (_, value) => {
        if (value && value.length > 3) {
          return Promise.reject('PfNumber should not exceed 3 letters!');
        }
        return Promise.resolve();
      };

  return (
    

    <Modal title="Add Designation"
    open={visible}
    okButtonProps={{ style: { background: 'grey' } }}
     onOk={handleOk} onCancel={handleCancel} footer={null}>
       <Form form={form} 
       style={{ display: 'flex', flexDirection: 'column' }}
        >
        <div className="bg-[#EDF3FD] rounded-[15px] px-3 pt-3 pb-4">
     
     <div className="block px-2">
           <Form.Item className='shiftLabel mb-3' label={<span>Designation Name <span style={{ color: 'red' }}>*</span></span>} name="designationName" >
               <Input className="!h-12 bg-[#CDDEF9] rounded-full !px-5 w-full border-none"/>
           </Form.Item>
           <Form.Item className='shiftLabel mb-3'
               label={<span>Short Name<span style={{ color: 'red' }}>*</span> (Maximum 5 letters are allowed)</span>}
               name="designationShortName"
             
           >
               <Input maxLength={5} className="!h-12 bg-[#CDDEF9] rounded-full !px-5 w-full border-none"/>
           </Form.Item>
           <Form.Item className='shiftLabel mb-3' label={<span>Description</span>} name="designationDescription"
            >
               <Input.TextArea className="!min-h-[100px] bg-[#CDDEF9] rounded-[10px] !px-5 w-full border-none !resize-none"/>
           </Form.Item>
               </div>
               </div>
           <div className="text-center mt-4">
           <Button
                  className="!border-[#6198ED] bg-[#6198ED] text-[#ffffff] hover:bg-[#ffffff] hover:!text-[#6198ED] rounded-full py-2 px-4 h-auto !text-sm !outline-none"
                  onClick={handleOk}
                >
                  <span className="font-sbold">+Add Designation</span>
                </Button>
                </div>
                
       </Form>
       
   </Modal>
   
  );
};

export default DesignationForm;
